import { Component, OnInit } from '@angular/core';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { DateTime } from 'luxon';
@Component({
  selector: 'app-holiday-decor',
  templateUrl: './holiday-decor.component.html',
  styleUrls: ['./holiday-decor.component.scss'],
  providers: [provideLuxonDateAdapter()],
  standalone: true,
})
export class HolidayDecorComponent implements OnInit {
  month = 1;
  year;
  constructor() {}
  ngOnInit(): void {
    this.month = DateTime.now().month;
    if (this.month === 1) {
      this.year = DateTime.now().year;
    }
  }
}
